import { providerLimitValues } from './provider-limit-values';
export var hasUserNoAvailableLimit = function (merchantResponseData, provider) {
    var limitValues = providerLimitValues(merchantResponseData, provider);
    return !limitValues || (limitValues && limitValues.available < 3000);
};
